/**
 * @desc 根据msku映射关系查询出对应的MSKU
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: defs.omsFlow.MskuRequestRpcDto, options?: any) {
  return updateResponse(
    http(URL + `/rpc/msku/getSkuByMsku`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
